/* eslint-disable no-undef */
import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
    state: {
        globalloading: false,
        api: axios.create({
            baseURL: lbfdata.rootapiurl,
            headers: {
                'content-type': 'application/json',
                'X-WP-Nonce': lbfdata.nonce
            },
        }),
    },
    actions: {
        async setMeasure({ commit }, measure) {
            commit('mutateSetMeasure', measure);
        },
    },
    mutations: {
        mutateStartLoading(state) {
            state.globalloading = true;
        },
    },
    getters: {
        allLocalRegistrants(state) {
            return state.localRegistrants;
        },
    },
    // plugins: [
    //     createPersistedState({
    //         key: "baytmstore",
    //         paths: ["cart", "catalogueCart", "currentLogo", "favourites"],
    //     }),
    // ],
});

export default store;
